import { render, staticRenderFns } from "./total.vue?vue&type=template&id=a74f98ec&scoped=true"
import script from "./total.vue?vue&type=script&lang=ts"
export * from "./total.vue?vue&type=script&lang=ts"
import style0 from "./total.vue?vue&type=style&index=0&id=a74f98ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74f98ec",
  null
  
)

export default component.exports